import GroupOptionsClassSearchabilityCheckbox from './GroupOptionsClassSearchabilityCheckbox';
import React from 'react';
import { isNil } from 'lodash';

const ClassSearchabilityContainer = ({
  classSearchabilityFromBackend,
  classSearchabilitySchoolDefault,
  groupUuid,
  toggleSearchable,
  classSearchabilityEnabled,
  setClassSearchabilityEnabled,
  disabled,
}: {
  classSearchabilityFromBackend: string;
  classSearchabilitySchoolDefault: string;
  groupUuid: string | null | undefined;
  toggleSearchable: () => void;
  classSearchabilityEnabled: string;
  setClassSearchabilityEnabled: (searchability: string) => void;
  disabled: boolean;
}) => {
  const checked = isNil(classSearchabilityEnabled)
    ? classSearchabilityFromBackend === 'searchable'
    : classSearchabilityEnabled === 'searchable';

  return (
    <GroupOptionsClassSearchabilityCheckbox
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ groupUuid: string | null | undefined; chec... Remove this comment to see the full error message
      groupUuid={groupUuid}
      checked={checked}
      classSearchabilitySchoolDefault={classSearchabilitySchoolDefault}
      disabled={disabled}
      onChange={(event, classSearchabilityMutation) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'checked' does not exist on type 'EventTa... Remove this comment to see the full error message
        const searchability = event.target.checked ? 'searchable' : 'unsearchable';
        if (classSearchabilityMutation) {
          classSearchabilityMutation({
            variables: { uuid: groupUuid, input: { searchability } },
          });
        } else {
          toggleSearchable();
        }
        setClassSearchabilityEnabled(searchability);
      }}
    />
  );
};

export default ClassSearchabilityContainer;
